@reference "@glow/tailwind-config/reference.css";

.chip {
  @apply rounded-sm;
  @apply flex;
  @apply justify-between;
  @apply gap-2;
  @apply p-2;
  @apply w-fit;
  @apply items-center;
}

.border {
  @apply border border-solid border-primary-500;
}

.chip.small {
  @apply min-h-8;
  @apply py-1;
}

.chip.default {
  @apply bg-primary-100;
  @apply text-primary-500;
}

.chip.include {
  @apply bg-success-light;
  @apply text-success-dark;
}

.chip.exclude {
  @apply bg-danger-light;
  @apply text-danger-dark;
}

.content {
  @apply text-xs;
}

.content.withButton {
  @apply pl-2;
}

.button {
  @apply border-none;
  @apply w-6;
  @apply h-6;
}

.button.default {
  @apply text-primary-500;
}

.button.default:hover {
  @apply text-primary-700;
}

.button.include {
  @apply text-success-dark;
}

.button.exclude {
  @apply text-danger-dark;
}
